/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IRewardHook, IRewardHookInterface } from "../IRewardHook";

const _abi = [
  {
    inputs: [],
    name: "onRewardClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IRewardHook__factory {
  static readonly abi = _abi;
  static createInterface(): IRewardHookInterface {
    return new utils.Interface(_abi) as IRewardHookInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IRewardHook {
    return new Contract(address, _abi, signerOrProvider) as IRewardHook;
  }
}
